/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPostResponse } from '../../models/get-post-response';

export interface GetActivityWithTranslations$Params {
  id: number;
}

export function getActivityWithTranslations(http: HttpClient, rootUrl: string, params: GetActivityWithTranslations$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPostResponse>> {
  const rb = new RequestBuilder(rootUrl, getActivityWithTranslations.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPostResponse>;
    })
  );
}

getActivityWithTranslations.PATH = '/api/activity-with-translations/{id}';
